module.exports = "/* input.ng-invalid.ng-touched,\r\ntextarea.ng-invalid.ng-touched {\r\n  border: 1px solid red;\r\n} */\r\n\r\n\r\n.InvalidZipCls{\r\n  border: 1px solid red;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/payment/payment.component.css
// module id = ./src/app/shoppingcart/payment/payment.component.css
// module chunks = main